import { render } from "./PatientNotes.vue?vue&type=template&id=93bbb166&ts=true"
import script from "./PatientNotes.ts?vue&type=script&lang=ts&external"
export * from "./PatientNotes.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__